// "In de media" carousel.
//
// CSS scroll-snap does the scrolling, so swipe, trackpad, scrollbar and keyboard all work with
// no JavaScript at all. This adds the page dots on top, which is why they are built here rather
// than server-side: without JS there is nothing to indicate, but the strip still scrolls.
//
// A page advances by whole cards, not by the visible width. The desktop view shows three and a
// half cards, so paging moves three and the half-cut card becomes the leftmost one.

function measure(track) {
	const card = track.querySelector('.media-card');
	if (!card) {
		return null;
	}

	const styles = window.getComputedStyle(track);
	const gap = parseFloat(styles.columnGap) || 0;
	const stride = card.getBoundingClientRect().width + gap;
	if (!(stride > 0)) {
		return null;
	}

	// Only the leading padding eats into the space cards occupy; there is none at the end.
	const available = track.clientWidth - (parseFloat(styles.paddingLeft) || 0);

	// How many cards fit whole. The trailing one has no gap after it, hence the + gap.
	const whole = Math.max(1, Math.floor((available + gap) / stride));

	const step = whole * stride;
	const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
	const pages = maxScroll <= 1 ? 1 : Math.ceil(maxScroll / step) + 1;

	return { step: step, pages: pages, maxScroll: maxScroll };
}

function activeIndex(track, state) {
	// At the very end the final step is usually a partial one, so snap the last dot on rather
	// than leaving it dark.
	if (track.scrollLeft >= state.maxScroll - 1) {
		return state.pages - 1;
	}
	return Math.min(state.pages - 1, Math.max(0, Math.round(track.scrollLeft / state.step)));
}

function setUpCarousel(root) {
	const track = root.querySelector('[data-media-track]');
	const dotsContainer = root.querySelector('[data-media-dots]');
	if (!track || !dotsContainer) {
		return;
	}

	let dots = [];
	let state = null;

	function markActive() {
		if (!dots.length || !state) {
			return;
		}
		const active = activeIndex(track, state);
		dots.forEach(function (dot, index) {
			const isActive = index === active;
			dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
			dot.classList.toggle('media-dot--active', isActive);
		});
	}

	function build() {
		const next = measure(track);
		if (!next) {
			return;
		}

		const samePages = state !== null && state.pages === next.pages;
		state = next;

		if (samePages) {
			markActive();
			return;
		}

		dotsContainer.textContent = '';
		dots = [];

		// One page means nothing to page through: the row stays empty and empty:hidden
		// collapses it away.
		if (state.pages < 2) {
			return;
		}

		for (let index = 0; index < state.pages; index++) {
			const dot = document.createElement('button');
			dot.type = 'button';
			dot.className = 'media-dot';
			dot.setAttribute('role', 'tab');
			dot.setAttribute('aria-label', 'Pagina ' + (index + 1) + ' van ' + state.pages);
			dot.addEventListener('click', function () {
				const target = Math.min(index * state.step, state.maxScroll);
				track.scrollTo({ left: target, behavior: 'smooth' });
			});
			dotsContainer.appendChild(dot);
			dots.push(dot);
		}

		markActive();
	}

	let queued = false;
	function onScroll() {
		if (queued) {
			return;
		}
		queued = true;
		window.requestAnimationFrame(function () {
			queued = false;
			markActive();
		});
	}

	track.addEventListener('scroll', onScroll, { passive: true });

	if (typeof ResizeObserver === 'function') {
		new ResizeObserver(build).observe(track);
	} else {
		window.addEventListener('resize', build);
	}

	build();
}

export default function registerMediaCarousels() {
	document.querySelectorAll('[data-media-carousel]').forEach(setUpCarousel);
}
